@if (env) {
  <!--
    `data-env` plutôt qu'une classe calculée : la couleur se lit d'un coup dans
    la feuille de styles, et un environnement inconnu retombe sur le gris.
    Les styles sont globaux (styles.css) parce que la hauteur du bandeau y est
    aussi celle du décalage du corps — un seul nombre, un seul endroit.
  -->
  <div class="env-bar" [attr.data-env]="env" role="status">
    <span class="env-bar__name">{{ env }}</span>
    <span class="env-bar__detail">{{ domain }}</span>
  </div>
}
